<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div
        class="page-title-box d-flex align-items-center justify-content-between"
      >
        <h4 class="mb-0 font-size-18">{{ title }}</h4>

        <div class="page-title-right">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li
                class="breadcrumb-item active"
                v-for="(item, index) in items"
                :key="index"
              >
                <router-link v-if="item.href" :to="item.href">
                  {{ item.text }}
                </router-link>
                <router-link v-else to="#">
                  {{ item.text }}
                </router-link>
              </li>
            </ol>
          </nav>
          <!-- <b-breadcrumb :items="items" class="m-0"></b-breadcrumb> -->
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
